import { FiGift, FiArrowRight } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

function getDateBadgeStyle(label) {
  if (label === "Today") {
    return "bg-gradient-to-r from-primary-600 to-primary-800 text-white shadow-sm";
  }

  if (label === "Tomorrow") {
    return "bg-amber-50 text-amber-600";
  }

  return "bg-gray-50 text-gray-500";
}

export default function BirthdayList({
  birthdays = [],
  isLoading = false,
}) {
  const navigate = useNavigate();

  return (
    <div className="h-full rounded-3xl border border-gray-100 bg-white p-6 shadow-sm transition-shadow duration-300 hover:shadow-md">
      <div className="mb-6 flex items-center justify-between">
        <div>
          <h2 className="text-lg font-semibold text-gray-900">
            Upcoming Birthdays
          </h2>

          <p className="mt-1 text-sm text-gray-500">
            Celebrate your team members
          </p>
        </div>

        <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-primary-600 to-primary-800">
          <FiGift size={20} className="text-white" />
        </div>
      </div>

      <div className="space-y-1">
        {isLoading ? (
          <div className="py-12 text-center text-sm text-gray-400">
            Loading birthdays…
          </div>
        ) : birthdays.length ? (
          birthdays.slice(0, 5).map((employee) => (
            <div
              key={employee.id}
              className="group flex items-center justify-between rounded-2xl p-3 transition-all duration-200 hover:bg-gray-50"
            >
              <div className="flex min-w-0 items-center gap-3">
                <div className="relative">
                  {employee.isToday ? (
                    <span className="absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center rounded-full bg-primary-600 ring-2 ring-white">
                      <FiGift className="text-white" size={9} />
                    </span>
                  ) : null}

                  <div className="flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-primary-600 to-primary-800 font-semibold text-white transition-transform duration-300 group-hover:scale-105">
                    {employee.fullName
                      ?.split(" ")
                      .map((word) => word[0])
                      .join("")
                      .slice(0, 2) || "—"}
                  </div>
                </div>

                <div className="min-w-0">
                  <p className="truncate font-medium text-gray-900">
                    {employee.fullName}
                  </p>

                  <p className="truncate text-sm text-gray-500">
                    {employee.designation || "Employee"}
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-2">
                <span
                  className={`whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-semibold ${getDateBadgeStyle(
                    employee.label,
                  )}`}
                >
                  {employee.label}
                </span>

                <button
                  type="button"
                  onClick={() =>
                    navigate(`/admindashboard/employees/${employee.id}`)
                  }
                  title={`Open ${employee.fullName}'s employee profile`}
                  className="flex h-8 w-8 items-center justify-center rounded-full text-gray-400 opacity-0 transition-all duration-200 hover:bg-primary-50 hover:text-primary-600 group-hover:opacity-100"
                >
                  <FiArrowRight size={14} />
                </button>
              </div>
            </div>
          ))
        ) : (
          <div className="py-12 text-center text-sm text-gray-400">
            No upcoming birthdays in the next 30 days.
          </div>
        )}
      </div>

      <button
        type="button"
        onClick={() => navigate("/admindashboard/employees")}
        className="group mt-4 flex w-full items-center justify-center gap-2 rounded-2xl border border-gray-200 py-3 text-sm font-semibold text-gray-600 transition-all duration-300 hover:border-gray-900 hover:bg-gray-900 hover:text-white"
      >
        View Employees
        <FiArrowRight className="transition-transform duration-300 group-hover:translate-x-1" />
      </button>
    </div>
  );
}
